import { Calendar, Clock } from "lucide-react";
import { format, parseISO, isSameDay } from "date-fns";
import { formatEventDateTime } from "../../lib/utils";
import type { Event } from "../../lib/types";

interface EventScheduleProps {
  event: Event;
}

export function EventSchedule({ event }: EventScheduleProps) {
  const iconColumnClass = "flex w-8 flex-shrink-0 items-center";
  return (
    <div className="space-y-4">
      {event.sessions && event.sessions.length > 1 && (
        <div className="flex items-center text-gray-600">
          <span className={iconColumnClass}>
            <Calendar className="w-5 h-5" />
          </span>
          <span>
            {
              formatEventDateTime(
                event.startsAt,
                event.endsAt,
                event.sessions,
              ).date
            }
          </span>
        </div>
      )}

      <div className="flex items-start text-gray-600">
        <span className={`${iconColumnClass} pt-0.5`}>
          <Clock className="w-5 h-5" />
        </span>
        <div className="flex-1 min-w-0">
          {event.sessions && event.sessions.length > 0 ? (
            <div className="space-y-2">
              {event.sessions.map((session, index) => {
                if (!session.startsAt || !session.endsAt) {
                  return null;
                }
                const startDate = parseISO(session.startsAt);
                const endDate = parseISO(session.endsAt);
                const isSame = isSameDay(startDate, endDate);

                return (
                  <div key={index} className="flex items-start gap-2">
                    <span className="text-gray-600">
                      {session.label ? (
                        <>
                          <span className="font-medium">{session.label}:</span>{" "}
                          {format(startDate, "EEEE, MMMM do, yyyy")}
                          {isSame ? (
                            <>
                              {" "}
                              {format(startDate, "h:mm a")} -{" "}
                              {format(endDate, "h:mm a")}
                            </>
                          ) : (
                            <>
                              {" "}
                              {format(startDate, "h:mm a")} -{" "}
                              {format(endDate, "EEEE, MMMM do, yyyy h:mm a")}
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          {format(startDate, "EEEE, MMMM do, yyyy")}
                          {isSame ? (
                            <>
                              {" "}
                              {format(startDate, "h:mm a")} -{" "}
                              {format(endDate, "h:mm a")}
                            </>
                          ) : (
                            <>
                              {" "}
                              {format(startDate, "h:mm a")} -{" "}
                              {format(endDate, "EEEE, MMMM do, yyyy h:mm a")}
                            </>
                          )}
                        </>
                      )}
                    </span>
                  </div>
                );
              })}
            </div>
          ) : (
            <span>
              {
                formatEventDateTime(
                  event.startsAt,
                  event.endsAt,
                  event.sessions,
                ).time
              }
            </span>
          )}
        </div>
      </div>
    </div>
  );
}






